import {
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CAlert,
} from '@coreui/react-pro'
import React, { useCallback, useEffect, useState } from 'react'
import AddForm from './AddForm'
import Table from './Table'
import PlayerService from 'src/service/PlayerService'
import useDebounce from 'src/hooks/useDebounce'
const Player = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})
  const [gameType, setGameType] = useState({})
  const dActivePage = useDebounce(activePage, 500)
  const dItemsPerPage = useDebounce(itemsPerPage, 500)
  const dColumnFilter = useDebounce(columnFilter, 500)
  const dColumnSorter = useDebounce(columnSorter, 500)
  const fetchUsers = useCallback(async () => {
    setLoading(true)
    const offset = dItemsPerPage * dActivePage - dItemsPerPage
    let params = new URLSearchParams()
    Object.keys(dColumnFilter).forEach((key) => {
      params.append(key, dColumnFilter[key])
    })
    dColumnSorter &&
      dColumnSorter.column !== undefined &&
      params.append('sort', `${dColumnSorter.column}%${dColumnSorter.state}`)

    try {
      const result = await PlayerService.getPlayers(offset, dItemsPerPage, dActivePage, params)
      setUsers(result.data)
      setGameType(result.game_type)
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
      setLoading(false)
    }
  }, [dActivePage, dItemsPerPage, dColumnFilter, dColumnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])
  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1} alwaysOpen>
          {gameType == 4 && (
            <CAlert color="danger">
              Restriction: You can create a maximum of 30 Player Records only
            </CAlert>
          )}
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Create Players</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <AddForm fetchUsers={fetchUsers} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Manage Players</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <Table
                users={users}
                setUsers={setUsers}
                fetchUsers={fetchUsers}
                setActivePage={setActivePage}
                setItemsPerPage={setItemsPerPage}
                setColumnFilter={setColumnFilter}
                setColumnSorter={setColumnSorter}
                itemsPerPage={itemsPerPage}
                activePage={activePage}
                columnFilter={columnFilter}
                columnSorter={columnSorter}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default Player
